import { Navigate, Outlet } from 'react-router-dom';
import { useAppContext } from '@/context/AppContext';
import { getDeviceVersionCode, isBelowMinSupportedVersion } from '@/utils/deviceDetails';
import { EAppFeature } from '@/constants';

const RHIVersionGate = () => {
  const { isWebView } = useAppContext();

  if (isWebView && (getDeviceVersionCode() === null || isBelowMinSupportedVersion(EAppFeature.RHI_SELF_CHECKOUT))) {
    return <Navigate to="/retail/health-insurance" replace />;
  }

  return <Outlet />;
};

export default RHIVersionGate;